import { Clock } from 'lucide-react';

/**
 * Format reading time for display
 * @param {number} minutes - Reading time in minutes
 * @returns {string} Formatted string like "5 min", "1h 20min"
 */
export function formatReadingTime(minutes) {
  if (!minutes || minutes < 1) return '1 min';
  
  if (minutes < 60) {
    return `${minutes} min`;
  }
  
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  
  if (remainingMinutes === 0) {
    return `${hours}h`;
  }
  
  return `${hours}h ${remainingMinutes}min`;
}

/**
 * Reading time display component with icon
 */
export function ReadingTime({ minutes, className = '', showIcon = true, size = 'default' }) {
  const sizeClasses = {
    small: 'text-xs',
    default: 'text-sm',
    large: 'text-base'
  };

  const iconSizes = {
    small: 'w-3 h-3',
    default: 'w-4 h-4',
    large: 'w-5 h-5'
  };

  return (
    <span className={`flex items-center gap-1 ${sizeClasses[size]} ${className}`}>
      {showIcon && <Clock className={iconSizes[size]} />}
      {formatReadingTime(minutes)}
    </span>
  );
}

export default ReadingTime;
